import { WhiteLabel } from 'app/types/white-labels';
import { isWhiteLabel } from 'app/utils/helpers';
import { isMobileNative } from 'app/utils/web-helpers';
import * as FileSystem from 'expo-file-system';
import md5 from 'md5';

export function getLocalCacheForImage(uri?: string | null) {
  if (!uri) return undefined;
  if (!isMobileNative) return undefined;
  const cacheKeyPrefix = isWhiteLabel(WhiteLabel.SerresTessier) ? 'serresv2-' : '';
  const cacheKey = md5(uri);
  const cacheUri = FileSystem.Paths.cache.uri;
  return `${cacheUri}${cacheKeyPrefix}${cacheKey}.png`;
}
